import React, { createContext, useContext, useState } from 'react'

interface AbcClientsContextData {
  setFilters: React.Dispatch<React.SetStateAction<any>>
  filters: any
}

export const AbcClientsContext = createContext<AbcClientsContextData>(
  {} as AbcClientsContextData
)

export const AbcClientsProvider: React.FC = ({ children }) => {
  const [filters, setFilters] = useState<any>({})

  return (
    <AbcClientsContext.Provider
      value={{
        setFilters,
        filters
      }}
    >
      {children}
    </AbcClientsContext.Provider>
  )
}

export function useAbcClientsContext() {
  return useContext(AbcClientsContext)
}
